import {ChangePasswordRequest} from "../model/request/auth/ChangePasswordRequest.ts";
import {CompleteEnrolementRequest} from "../model/request/auth/CompleteEnrolementRequest.ts";
import {CompletePasswordReset} from "../model/request/auth/CompletePasswordReset.ts";
import {LoginRequest} from "../model/request/auth/LoginRequest.ts";
import {ResetPassword} from "../model/request/auth/ResetPassword.ts";
import {SignUpRequest} from "../model/request/auth/SignUpRequest.ts";
import {BaseService} from "@/service/BaseService.ts";
import {ResendOtpRequest} from "@/model/request/auth/ResendOtpRequest.ts";

export class AuthService {
    static login = (others: any, data: LoginRequest) => {
        return BaseService.apiClient(others).post("/authentication/login", data);
    };

    static signup = (others: any, data: SignUpRequest) => {
        return BaseService.apiClient(others).post(
            "/authentication/initiate-enrollment",
            data
        );
    };

    static completeEnrollment = (others: any, data: CompleteEnrolementRequest) => {
        return BaseService.apiClient(others).post(
            "/authentication/complete-enrollment",
            data
        );
    };


    static reset = (others: any, data: ResetPassword) => {
        return BaseService.apiClient(others).post("/authentication/initiate-password-reset", data);
    };
    static resendOtp = (others: any, data: ResendOtpRequest) => {
        return BaseService.apiClient(others).post("/authentication/resend-otp", data);
    };

    static resetPassword = (others: any, data: CompletePasswordReset) => {
        return BaseService.apiClient(others).post(
            "/authentication/complete-password-reset",
            data
        );
    };
    static changePassword = (others: any, data: ChangePasswordRequest) => {
        return BaseService.apiClient(others).post(
            "/authentication/change-password",
            data
        );
    };
}
